/**
 * ProTableListForm 表格单元格内控件的统一尺寸契约（REM 基准）。
 *
 * 【为何需要】表格单元格宽度由列宽决定（可能很窄，如「考核指标」列），但：
 *  - 控件本体需撑满 cell 的 render 区域（否则留白、点击区域小）；
 *  - 下拉展开后的面板需按最小宽度保底（否则选项文本被截断，无法辨认）。
 * 二者诉求不同，故分开约束：本体 `width: 100%`，下拉面板 `minWidth` 保底。
 *
 * 【REM 铁律】项目根字号为动态缩放基准（1px ↔ 1rem），所有尺寸必须经 `localPx2rem`
 * 换算为 rem，禁止直接写 px 字面量——直接写 px 不随屏幕适配缩放。
 */
import { localPx2rem } from '@mpc/common/src/utils';

/** 单元格内下拉面板的最小宽度（设计值 px，经 localPx2rem 换算） */
export const CELL_SELECT_DROPDOWN_MIN_WIDTH = 240;

/**
 * 选项数**超过**该值的下拉才提供搜索框：2 选项下拉加搜索框无收益，反而占据面板首行。
 *
 * 供拿不到业务语义的**引擎通用下拉**判定；业务侧静态可知的 2 选项下拉直接写 `showSearch={false}`。
 */
export const MIN_SEARCHABLE_OPTION_COUNT = 2;

/**
 * 单元格内 Select 的统一下拉配置：本体宽度跟随 cell、下拉面板 240px 保底，且**统一开启搜索**
 * —— 收口点，凡展开本常量的下拉即自动带搜索，新增下拉无需各自声明。
 *
 * ⚠️ 关掉某处搜索时 `showSearch={false}` **必须写在展开之后**，否则被本常量覆盖回 `true`（静默失效）。
 * ⚠️ 用 `true` 而非 `'inner'`：后者把搜索框内联进本体、挤占窄列。
 * 不传 `filterOptions`：基础 Select 默认按 `name` 做**大小写不敏感**的子串匹配，已满足需求。
 */
export const CELL_SELECT_DROPDOWN_PROPS = {
  dropdownStyle: { minWidth: localPx2rem(CELL_SELECT_DROPDOWN_MIN_WIDTH) },
  showSearch: true,
};

/** 单元格内受控控件统一宽度：撑满 cell 的 render 区域 */
export const CELL_CONTROL_WIDTH_STYLE = { width: '100%' };
